export default "__VITE_ASSET__BynBLTre__"